export const baseEnvironment = {
  API_URL: '/baseEnvUrl',
  base: true,
  reqTimeout: 300000,
  websiteDetails: {
    name: 'https://www.pcarelink.com'
  },
  supportEmail: 'support@pcarelink.com',
  apiEndPoints: {
    auth: {
      login: '/auth/login',
      azureSSOLogin: '/auth/azurelogin'
    },
    public: {
      forgotPassword: '/auth/forgot-password'
    },
    guarantorPayments: {
      base: '/guarantor',
      payment: '/payment',
      endPoints: {
        getToken: '/token',
        verifyToken: '/token/verify',
        login: '/login',
        patientDetails: '/patient',
        sendEmail: '/statement/email-link',
        patientInvoiceLines: '/patient/:patient_id/statement',
        paymentHistory: '/payment',
        paymentConfirmation: '/payment/email-confirmation',
        instaMedMakePayment: '/payment/instamed',
        openEdgeMakePayment: '/payment/open-edge/create-transaction',
        guarantorLogoff: '/guarantor/logoff' // api to logout guarantor
      }
    },
    incomingSms: {
      all: 'incoming-sms/all',
      countAll: 'incoming-sms/count/all'
    },
    messages: {
      base: '/messages',
      endPoints: {
        conversation: '/conversation',
        respond: '/respond',
        archive: '/archive',
        markRead: '/mark-read',
        matchedGuarantors: '/matched-guarantors',
        changeGuarantor: '/change-guarantor',
        eventTypeStatus: '/event-type-status'
      }
    },
    reference: {
      base: '/reference-data'
    },
    profile: {
      me: '/user/me',
      changePassword: '/user/change-password',
      userAuthMeta: '/user/auth-meta',
      logout: '/user/logout',
      setNotification: '/user/set-notification',
      getNotifications: '/user/notifications',
      logoff: '/user/logoff' // api to logout user from web
    },
    inventory: {
      itemDetail: '/scanner/drug-details',
      details: '/inventory/details',
      completeDetails: '/inventory/complete-details',
      add: '/inventory/add-drug',
      checkOut: '/inventory/check-out',
      checkOutDetail: '/inventory/checkout-details',
      lotDetail: '/inventory/lot-details',
      checkReceivedItem: '/inventory/check-received-item',
      returnVaccine: '/inventory/return'
    },
    returnVac: {
      getAllByPeriodWithCounts: '/vaccines/returned'
    },
    orderHistory: {
      base: '/inventory/order-history'
    },
    expire: {
      expiringSoon: '/vaccines/expiring',
      expiredDetails: '/vaccines/expired',
      totalVaccinesDetailsUrl: '/vaccines/list/all',
      runningLow: '/vaccines/running-low'
    },
    clinics: {
      getAll: '/clinics/all'
    },
    metrics: {
      cardsCount: '/metrics/vaccines/card-counts',
      monthWiseVaccines: '/metrics/vaccines/month-wise',
      returnedVaccines: '/metrics/vaccines/returned-month-wise'
    },
    allVaccines: {
      systemVaccineList: '/vaccine-list',
      allVaccinesDetails: '/vaccines/all'
    },
    vfcReport: {
      report: '/vfc-report'
    }
  }
};
